import React, { useState, useEffect } from "react";
import { Box, Typography, Stack } from "@mui/material";
import { Images } from "./../../assets/common";
import { useHistory } from "react-router-dom";
import ApiService from "./../../services/api-service";
import "./index.scss";
import { validateUrl } from "../../constants/function";
import notifier from "../Notifier";
import Loader from "./../../components/Loader";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export default function TopBanner() {
  const [banner, setBanner] = useState([]);

  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const getBanner = async () => {
    try {
      setLoading(true);
      const response = await ApiService.BANNER();
      setBanner([...response["result"]["data"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getBanner();
  }, []);

  const history = useHistory();

  return (
    <div style={{ position: "relative" }}>
      <Box className="__topBanner _cp" sx={{ zIndex: 0 }}>
        {banner && banner.length > 0 ? (
          <Carousel
            currentIndex={currentIndex}
            showThumbs={false}
            autoPlay={true}
            interval={5000}
            transitionTime={500}
            stopOnHover={true}
            swipeable={true}
            emulateTouch={true}
            autoFocus={true}
            infiniteLoop={true}
            onChange={(index) => {
              setCurrentIndex(index);
            }}
            onClickItem={(item) => {
              //console.log(item);
              validateUrl(banner[item]["url"])
                ? window.open(banner[item]["url"], "_blank")
                : notifier.info("Unable to open link Please check URL");
            }}
          >
            {banner.map((b, index) => (
              <img
                key={index}
                className="__topBanner_image"
                src={b["image"] ? b["image"]["filePath"] : ""}
                alt="Twitter"
              />
            ))}
          </Carousel>
        ) : null}
        {loading ? <Loader /> : null}
      </Box>
      <Box className="__behindBanner _cp" sx={{ zIndex: -1 }}>
        {banner && banner.length > 0 ? (
          <Carousel
            showArrows={false}
            showStatus={false}
            showIndicators={false}
            currentIndex={currentIndex}
            selectedItem={currentIndex}
            showThumbs={false}
            autoPlay={false}
            interval={5000}
            transitionTime={500}
            stopOnHover={false}
            swipeable={true}
            emulateTouch={true}
            autoFocus={true}
            infiniteLoop={true}
          >
            {banner.map((b, index) => (
              <img
                key={index}
                className="__behindBanner_image"
                src={b["image"] ? b["image"]["filePath"] : ""}
                alt="Twitter"
              />
            ))}
          </Carousel>
        ) : null}
        {loading ? <Loader /> : null}
      </Box>
    </div>
  );
}
